/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PPTLBase, PPTLBaseInterface } from "../PPTLBase";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "default_admin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type PPTLBaseConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PPTLBaseConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PPTLBase__factory extends ContractFactory {
  constructor(...args: PPTLBaseConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "PPTLBase";
  }

  deploy(
    default_admin: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PPTLBase> {
    return super.deploy(default_admin, overrides || {}) as Promise<PPTLBase>;
  }
  getDeployTransaction(
    default_admin: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(default_admin, overrides || {});
  }
  attach(address: string): PPTLBase {
    return super.attach(address) as PPTLBase;
  }
  connect(signer: Signer): PPTLBase__factory {
    return super.connect(signer) as PPTLBase__factory;
  }
  static readonly contractName: "PPTLBase";
  public readonly contractName: "PPTLBase";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PPTLBaseInterface {
    return new utils.Interface(_abi) as PPTLBaseInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PPTLBase {
    return new Contract(address, _abi, signerOrProvider) as PPTLBase;
  }
}
